import { WarningSquareIcon } from "@/domains/icons"

export const InnerCardWarning = ({ warning }: { warning: string }) => {
  return (
    <div className="flex items-center gap-1 whitespace-nowrap text-sm text-[#FF6C66]/75">
      <WarningSquareIcon className="mt-[1px] h-3 w-3" size={13} /> {warning}
    </div>
  )
}
